export default "__VITE_ASSET__$soym89X__"